import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import Modal from 'components/Modal';

import { Container } from './styles';

const ServerErrorModal = () => {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen
            fullscreen
            withRoundedCorners={false}
            dataLocator="serverErrorModal"
            customStyles={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Container>
                <Text type="h3" mb={20} bold center>
                    {t('basic.serverError.title')}
                </Text>
                <Text mb={4} center type="large-text">
                    {t('basic.serverError.description1')}
                </Text>
                <Text center type="large-text">
                    {t('basic.serverError.description2')}
                </Text>
            </Container>
        </Modal>
    );
};

export default ServerErrorModal;
